import { Chart as ChartJS } from 'chart.js';

// Plugin to add subtle shadow to bar and arc (pie/doughnut) elements
// Configure via options.plugins.elementShadow
export const elementShadowPlugin = {
  id: 'elementShadow',
  beforeDatasetDraw(chart: ChartJS, args: any, pluginOptions: any) {
    const { ctx } = chart as any;
    const type = args?.meta?.type;
    const enabled = pluginOptions?.enabled ?? true;
    if (!enabled) return;
    if (type === 'bar' || type === 'doughnut' || type === 'pie') {
      ctx.save();
      ctx.shadowColor = pluginOptions?.color ?? 'rgba(0,0,0,0.18)';
      ctx.shadowBlur = pluginOptions?.blur ?? 10;
      ctx.shadowOffsetX = pluginOptions?.offsetX ?? 2;
      ctx.shadowOffsetY = pluginOptions?.offsetY ?? 4;
    }
  },
  afterDatasetDraw(chart: ChartJS) {
    const { ctx } = chart as any;
    ctx.restore();
  },
};

export default elementShadowPlugin;
